import React from 'react';
import { FadeIn } from './ui/FadeIn';
const chatImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/t9PcyGJtSTnjb3jjo8Jm7P/caht_4.png',
  alt: 'Testimonio de Camila Serna — dormí 7 horas seguidas por primera vez'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/icDhgF2R6b69Took7MNPbN/chat_2.png',
  alt: 'Testimonio de Susu Hidalgo — por fin puedo desconectarme del trabajo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qo7LRYrD2Up7Vue5pVQYea/chat_5.png',
  alt: 'Testimonio de Miriam Jara — por fin podía relajarme después del trabajo'
}];
export function Testimonials() {
  return <section className="px-6 py-10 max-w-3xl mx-auto" data-id="element-197">
      <FadeIn data-id="element-198">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A5D3A] text-center mb-3" data-id="element-199">
          Lo que dicen quienes ya lo probaron
        </h2>
        <p className="text-center text-[#2D2A26]/60 mb-10 text-lg" data-id="element-200">
          Conversaciones reales. Sin editar.
        </p>
      </FadeIn>

      <div className="space-y-8" data-id="element-201">
        {chatImages.map((chat, i) => <FadeIn key={i} delay={i * 0.12} data-id="element-202">
            <img src={chat.src} alt={chat.alt} className="w-full max-w-md mx-auto rounded-2xl shadow-lg" data-id="element-203" />
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-204">
        <div className="text-center mt-10" data-id="element-205">
          <a href="https://pay.hotmart.com/Y104754180A" className="inline-block w-full max-w-md mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-lg md:text-xl" data-id="element-206">
            SÍ — YO TAMBIÉN QUIERO DORMIR ASÍ → Acceso instantáneo · Solo $6.39
            USD
          </a>
        </div>
      </FadeIn>
    </section>;
}